import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    ChangeContractBeginStatus: 'idle',
    ChangeContractBeginError: undefined as any,

    flbelBeginList: [] as any[],
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const ChangeContractBegin = createAsyncThunk('flbelBeginSlice/ChangeContractBegin', async ({ parentModel, flbelBegin }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/ContractMenu_ChangeContractBegin/`,
        prepareData({ FlbelId: parentModel.HDR_ID, ContractBeginOld: flbelBegin.OldContractBegin, ContractBeginNew: flbelBegin.NewContractBegin }),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { ChangeContractBeginStatus } = getState().flbelBeginSlice
        return ChangeContractBeginStatus !== 'pending'
    }
})

const FlbelBeginSlice = createSlice({
    name: 'flbelBeginSlice',
    initialState,
    reducers: {
        resetChangeContractBeginError: (state) => {
            state.ChangeContractBeginError = undefined
        },
        removeFromFlbelBeginListById: (state, action) => {
            state.flbelBeginList = state.flbelBeginList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromFlbelBeginListByIds: (state, action) => {
            state.flbelBeginList = state.flbelBeginList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.flbelBeginList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.ChangeContractBeginStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.flbelBeginList = []
            state.ChangeContractBeginStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(ChangeContractBegin.pending, (state) => {
            state.ChangeContractBeginStatus = 'pending'
            state.ChangeContractBeginError = undefined
        })
        builder.addCase(ChangeContractBegin.fulfilled, (state, action) => {
            state.ChangeContractBeginStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flbelBeginList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flbelBeginList.push(newItem) }
                else { state.flbelBeginList[i] = { ...state.flbelBeginList[i], ...newItem } }
            }
        })
        builder.addCase(ChangeContractBegin.rejected, (state, action) => {
            state.ChangeContractBeginStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.ChangeContractBeginError = action.error.message
            } else {
                state.ChangeContractBeginError = action.payload
            }
        })

    }
})

export const {
    resetChangeContractBeginError,
    removeFromFlbelBeginListById,
    removeFromFlbelBeginListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = FlbelBeginSlice.actions
export default FlbelBeginSlice.reducer
